import styled from 'styled-components';

export const ContainerInputSearch = styled.div`
  margin: 0px 3px;
`;
